export default __webpack_public_path__ + "static/media/allAnimeLogo5.0251b0e5.png";